import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FiClock } from "react-icons/fi";

function OfficeHoursDialog({
  open,
  title,
  saving = false,
  saveLabel = "Save",
  errorText = "",
  children,
  onSubmit,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !saving) onCancel?.();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, saving, onCancel]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="dd-confirm dd-hours-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dd-hours-dialog-title"
    >
      <button
        type="button"
        className="dd-confirm__backdrop"
        aria-label="Close"
        onClick={() => (!saving ? onCancel?.() : null)}
      />
      <form className="dd-confirm__panel" onSubmit={onSubmit} noValidate>
        <div className="dd-hours-dialog__icon" aria-hidden>
          <FiClock size={20} />
        </div>
        <h3 id="dd-hours-dialog-title">{title}</h3>
        {errorText ? (
          <p className="dd-hours-alert dd-hours-alert--error" role="alert">
            {errorText}
          </p>
        ) : null}
        <div className="dd-hours-dialog__fields">{children}</div>
        <div className="dd-confirm__actions">
          <button
            type="button"
            className="dd-confirm__btn dd-confirm__btn--ghost"
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="dd-confirm__btn dd-confirm__btn--primary"
            disabled={saving}
          >
            {saving ? `${saveLabel}…` : saveLabel}
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
}

export default OfficeHoursDialog;
